import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from 'src/utils/base-query.js'

// Define a service using a base URL and expected endpoints
export const whiteLabelTeamMemberManagementApi = createApi({
  reducerPath: 'whiteLabelTeamMemberManagementApi',
  baseQuery,
  endpoints: (builder) => ({
    sendInvitation: builder.mutation({
      query: (data) => {
        return {
          method: 'POST',
          url: 'team-management/team-member/invitation',
          body: data
        }
      }
    }),
    updateInvitationStatus: builder.mutation({
      query: ({ id, ...data }) => {
        return {
          method: 'PUT',
          url: 'team-management/team-member/invitation-status',
          body: data
        }
      }
    }),
    getInvitation: builder.mutation({
      query: (id) => {
        return {
          method: 'GET',
          url: `/team-management/team-member/invitation?invitationToken=${id}`
        }
      },
      transformResponse: (response) => response?.data
    }),
    getMembers: builder.mutation({
      query: (data) => {
        return {
          method: 'GET',
          url: `team-management/team-members?status=${data.status}`
        }
      }
    }),
    deleteMember: builder.mutation({
      query: (payload) => {
        return {
          method: 'DELETE',
          url: `team-management/team-member/${payload.id}/user/${payload.userId}`
        }
      }
    }),
    fetchWhiteLabelDetails: builder.mutation({
      query: ({ partnerId, email }) => {
        return {
          method: 'GET',
          url: `team-management/partner/branding/${partnerId}/${email}`
        }
      }
    }),
    updateMemberPermissions: builder.mutation({
      query: (payload) => {
        return {
          method: 'PUT',
          url: `team-management/team-member/permissions/${payload._id}/user/${payload.userId}`,
          body: { permissions: payload.permissions }
        }
      }
    }),
    updateTeamMemberAssignUsers: builder.mutation({
      query: (data) => {
        return {
          method: 'PUT',
          url: 'team-management/team-member/update-assigned-users',
          body: { data }
        }
      }
    }),
    getUserPermissions: builder.query({
      query: () => {
        return {
          method: 'get',
          url: 'team-management/member/user-permissions'
        }
      }
    })
  })
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useSendInvitationMutation,
  useUpdateInvitationStatusMutation,
  useGetInvitationMutation,
  useGetMembersMutation,
  useDeleteMemberMutation,
  useFetchWhiteLabelDetailsMutation,
  useUpdateMemberPermissionsMutation,
  useGetUserPermissionsQuery,
  useUpdateTeamMemberAssignUsersMutation
} = whiteLabelTeamMemberManagementApi
